import { Component, Input, OnChanges } from '@angular/core';
import {
  getProfielnaamWithoutFallback,
  getUitnodigingStatusLabel,
  UitnodigingStatus,
  validatedProfielId,
} from 'parkour-web-app-dto';
import { Uitnodiging } from '../../../uitnodiging/model/uitnodiging';
import { map, Observable, of } from 'rxjs';
import { ParkourActionComponent, ParkourTagComponent } from '@parkour/ui';
import { AsyncPipe } from '@angular/common';
import { ProfielFotoPipe } from '../../../shared/pipes/profiel-foto.pipe';
import { TeammemberUitnodigingItemComponent } from '../teammember-uitnodiging-item/teammember-uitnodiging-item.component';
import { TeamlidProfiel } from '../../model/teamlid.model';
import { TeamService } from '../../service/team.service';
import { ProfielnaamPipe } from '../../../shared/pipes/profielnaam.pipe';

@Component({
  standalone: true,
  selector: 'parkour-teammember-uitnodiging',
  templateUrl: './teammember-uitnodiging.component.html',
  imports: [
    ParkourActionComponent,
    ProfielFotoPipe,
    AsyncPipe,
    ParkourTagComponent,
    TeammemberUitnodigingItemComponent,
    ProfielnaamPipe,
  ],
})
export class TeammemberUitnodigingComponent implements OnChanges {
  @Input({ required: true }) uitnodiging!: Uitnodiging;
  aanvaardeUitnodiging$ = new Observable<
    | {
        profiel: TeamlidProfiel;
      }
    | 'NOT_AANVAARD'
  >();
  protected readonly getProfielnaamWithoutFallback = getProfielnaamWithoutFallback;

  constructor(private readonly teamService: TeamService) {}

  ngOnChanges(): void {
    this.aanvaardeUitnodiging$ =
      this.uitnodiging.status === 'AANVAARD'
        ? this.teamService
            .getTeamlidInCurrentContext(validatedProfielId(this.uitnodiging.profielId))
            .pipe(map((profiel) => ({ profiel })))
        : of('NOT_AANVAARD');
  }

  getStatusLabel(status: UitnodigingStatus): string {
    return getUitnodigingStatusLabel(status);
  }
}
